module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"sales_funnel":"Sales Funnel","product_ranking":"Product Ranking","sales_team_ranking":"Sales Team Ranking"},"id":{"sales_funnel":"Funnel Penjualan","product_ranking":"Peringkat Produk","sales_team_ranking":"Peringkat Tim Penjualan"}}')
  delete Component.options._Ctor
}
